import { UserWithOrdersType } from 'views/EspaceProf/tabs/ControlTab';

export const getNumberOfOrdersByPaymentStatus = (
  usersWithOrders: UserWithOrdersType[]
) => {
  let numberOfOrders = 0;
  let numberOfPayedOrders = 0;
  let numberOfUnPayedOrders = 0;
  let numberOfCanceledOrders = 0;

  usersWithOrders.forEach(user => {
    user.commandes.forEach(commande => {
      if (commande.status === 'PAYE') {
        numberOfPayedOrders++;
      } else if (
        commande.status !== 'PAYE' &&
        commande.status !== 'ANNULE' &&
        commande.status !== 'A_FINALISER'
      ) {
        numberOfUnPayedOrders++;
      } else if (commande.status === 'ANNULE') {
        numberOfCanceledOrders++;
      }
    });
    numberOfOrders += user.commandes.length;
  });

  return {
    numberOfOrders: numberOfOrders,
    numberOfPayedOrders: numberOfPayedOrders,
    numberOfUnPayedOrders: numberOfUnPayedOrders,
    numberOfCanceledOrders: numberOfCanceledOrders
  };
};
